export default __webpack_public_path__ + "63697811c3a7a1d89888b725d079f23f.png";